<template>
  <div class="substep-invite-members">
    <div class="substep-header">
      <h3 data-testId="step-title">Invite Members</h3>
      <p>Invite members to your team by entering their email addresses.</p>
    </div>
    <AppButton
      v-if="showInvites"
      class="btn-secondary main-button"
      @click="toggleView"
    >
      Invite another member
    </AppButton>
    <div class="substep-body">
      <AppTable
        v-if="showInvites"
        :table-data="invites"
        class="invites-table"
        :loading="showLoading"
      >
        <AppTableColumn
          v-slot="{ row }"
          header="Email"
        >
          <span>{{ row.email }}</span>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Role"
        >
          <span>{{ formatRole(row.role) }}</span>
        </AppTableColumn>
      </AppTable>
      <div
        v-else
        class="embedded-form-box"
      >
        <div class="embedded-form-box-body">
          <label class="control-label">EMAIL</label>
          <div
            v-for="(invite, index) in newInvites"
            :key="index"
            class="field-line"
          >
            <div class="input-combo">
              <AppInput
                v-model="invite.email"
                placeholder="Add an email"
                type="email"
              />
              <AppSelect
                v-model="invite.role"
                :options="roles"
                :select2-options="select2Options"
                placeholder="Select a role"
              />
            </div>
            <div class="errors">
              {{ errorMessages[index] }}
            </div>
          </div>
        </div>
        <div>
          <a
            v-if="canAddInvites"
            href="#"
            @click="addInvite($event)"
          >
            + Add another member
          </a>
        </div>
        <div class="embedded-form-box-footer">
          <AppButton
            class="btn-secondary"
            @click="toggleView"
          >
            Cancel
          </AppButton>
          <AppButton
            class="btn-primary"
            :disabled="showLoading"
            @click="inviteMembers"
          >
            Send
          </AppButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import AppInput from '~/components/AppInput.vue';
import AppTable from '~/components/AppTable.vue';
import AppButton from '~/components/AppButton.vue';
import { InvitesResource } from '~/resources';

export default {
  name: 'InviteMembers',
  components: {
    AppButton,
    AppInput,
    AppTable,
  },
  mixins: [GettingStartedMixin],
  props: {
    invites: {
      type: Array,
      default: () => [],
      validator: (invites) => {
        return invites.every((invite) => {
          return !!invite.id && !!invite.email && typeof invite.role === 'number';
        });
      },
    },
    organization: {
      type: Object,
      required: true,
      validator: (organization) => {
        return !!organization.id;
      },
    },
  },
  data: () => ({
    showInvites: false,
    newInvites: Array.from({ length: 3 }, () => {
      return { email: '', role: 0 };
    }),
    showLoading: false,
    errorMessages: [],
    roles: [
      { id: '0', text: 'User' },
      { id: '2', text: 'Manager' },
    ],
    select2Options: Object.freeze({
      allowClear: false,
      multiple: false,
    }),
  }),
  computed: {
    canAddInvites: {
      get() {
        return this.newInvites.length < 20;
      },
    },
  },
  watch: {
    invites: {
      handler() {
        this.checkInvites();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    $('.select2').select2({});
  },
  methods: {
    async toggleView() {
      this.showInvites = !this.showInvites;
    },
    async addInvite(event) {
      event.preventDefault();
      this.newInvites.push({ email: '', role: '0' });
    },
    async inviteMembers() {
      this.errorMessages = [];
      this.showLoading = true;
      const params = {
        invite: this.newInvites.filter((invite) => invite.email),
        source: 'Getting Started Invite Members'
      };

      try {
        const response = await InvitesResource.bulkCreate({ id: this.organization.id }, params, {});

        if (response.success) {
          this.$emit('reloadSubstep');
          this.newInvites = Array.from({ length: 3 }, () => {
            return { email: '', role: 0 };
          });
          this.toggleView();
        } else if (response.errors) {
          this.errorMessages = response.errors;
        }
      } finally {
        this.showLoading = false;
      }
    },
    checkInvites() {
      if (this.invites.length > 0) {
        this.$emit('completeSubstep');
      }
    },
    formatRole(role) {
      return this.roles.find((r) => r.id === role.toString()).text;
    },
  },
};
</script>
